export default new class webconfig
{
    //WebApi="https://app.5201000.com";
    //WebApi="http://api.ttzj.cn";
    //WebApi="http://apix.ttzj.cn";
    //WebApi="http://aja.5201000.com";
    //WebApi="http://api.heaven.com";
    //WebApi="http://192.168.2.88:8082";
    //WebApi="/api";
    // WebApi="http://192.168.2.88:8055";
    // WebApi="http://192.168.2.88:8011";
     WebApi="http://api.xiaoaitt.com";
     WebDomin="http://www.xettw.com";
    // WebApi="http://tapi.xiaoaitt.com";
    Grant_Type="password";
    Appid="Heaven";
    Secret="CDE561BE-3B9C-4DAA-A089-5B26E4A2C93B";
}